import {Spin} from "antd";
import {LoadingSpinner} from "../../../icons/icons";
import {CustomerCallsSection} from "../calls-section/customer";
import {
  StyledUpcomingCallsWrapper,
  StyledNoUpcomingCallBox,
} from "../upcoming-calls.style";
import {useGetCustomerUpcomingCallsContext} from "../../../../context/upcoming-calls/customer";

const CustomerUpcomingCallsComponent = () => {
  const {
    state: {
      customerUpcomingCallsData: {session},
      isFetchingCustomerUpcomingCalls,
    },
  } = useGetCustomerUpcomingCallsContext();

  return (
    <StyledUpcomingCallsWrapper>
      <>
        {session.length < 1 ? (
          <Spin
            spinning={isFetchingCustomerUpcomingCalls}
            tip="Updating..."
            indicator={LoadingSpinner}
          >
            <StyledNoUpcomingCallBox>
              <p className="info-text">
                {isFetchingCustomerUpcomingCalls
                  ? ""
                  : "You do not have any upcoming 1:1 sessions"}
              </p>
            </StyledNoUpcomingCallBox>
          </Spin>
        ) : (
          <Spin
            spinning={isFetchingCustomerUpcomingCalls}
            tip="Updating..."
            indicator={LoadingSpinner}
          >
            <CustomerCallsSection />
          </Spin>
        )}
      </>
    </StyledUpcomingCallsWrapper>
  );
};

export {CustomerUpcomingCallsComponent};
